/* eslint-disable react/no-unescaped-entities */

import React from "react";
import { Link } from "react-router-dom";
import "../../../style/icons/remix/fonts/remixicon.css"
const RemixIcons = () => {
  return (
    <>
    {/* Page Wrapper */}
    <div className="page-wrapper cardhead">
      <div className="content">
        {/* Page Header */}
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <h3 className="page-title">Remix Icon</h3>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          {/* Chart */}
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">Remix Icons</div>
              </div>
              <div className="card-body">
                <p className="mb-2">
                  <code>&lt;i className="ri-ICON_NAME"&gt;&lt;/i&gt;</code>. For more
                  information{" "}
                  <Link
                    to="https://remixicon.com/"
                    target="_blank"
                    className="text-primary"
                  >
                    click here
                  </Link>
                  .
                </p>
                <div className="icons-items">
                  <div className="icons-list">
                    <div className="icons-list-item">
                      <i
                        className="ri-home-line"
                        data-bs-toggle="tooltip"
                        title="ri-home-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-dashboard-3-line"
                        data-bs-toggle="tooltip"
                        title="ri-dashboard-3-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-map-pin-2-line"
                        data-bs-toggle="tooltip"
                        title="ri-map-pin-2-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-message-2-line"
                        data-bs-toggle="tooltip"
                        title="ri-message-2-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-group-line"
                        data-bs-toggle="tooltip"
                        title="ri-group-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-image-line"
                        data-bs-toggle="tooltip"
                        title="ri-image-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-file-line"
                        data-bs-toggle="tooltip"
                        title="ri-file-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-line-chart-line"
                        data-bs-toggle="tooltip"
                        title="ri-line-chart-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-exchange-line"
                        data-bs-toggle="tooltip"
                        title="ri-exchange-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-menu-line"
                        data-bs-toggle="tooltip"
                        title="ri-menu-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-settings-5-line"
                        data-bs-toggle="tooltip"
                        title="ri-settings-5-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-building-4-line"
                        data-bs-toggle="tooltip"
                        title="ri-building-4-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-shopping-cart-2-line"
                        data-bs-toggle="tooltip"
                        title="ri-shopping-cart-2-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-video-chat-line"
                        data-bs-toggle="tooltip"
                        title="ri-video-chat-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-notification-3-line"
                        data-bs-toggle="tooltip"
                        title="ri-notification-3-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-mail-settings-line"
                        data-bs-toggle="tooltip"
                        title="ri-mail-settings-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-map-pin-line"
                        data-bs-toggle="tooltip"
                        title="ri-map-pin-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-pie-chart-line"
                        data-bs-toggle="tooltip"
                        title="ri-pie-chart-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-checkbox-line"
                        data-bs-toggle="tooltip"
                        title="ri-checkbox-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-check-double-line"
                        data-bs-toggle="tooltip"
                        title="ri-check-double-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-archive-line"
                        data-bs-toggle="tooltip"
                        title="ri-archive-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-arrow-down-s-line"
                        data-bs-toggle="tooltip"
                        title="ri-arrow-down-s-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-arrow-right-double-fill"
                        data-bs-toggle="tooltip"
                        title="ri-arrow-right-double-fill"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-download-cloud-line"
                        data-bs-toggle="tooltip"
                        title="ri-download-cloud-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-database-2-line"
                        data-bs-toggle="tooltip"
                        title="ri-database-2-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-computer-line"
                        data-bs-toggle="tooltip"
                        title="ri-computer-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-discount-percent-line"
                        data-bs-toggle="tooltip"
                        title="ri-discount-percent-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-more-2-fill"
                        data-bs-toggle="tooltip"
                        title="ri-more-2-fill"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-download-2-line"
                        data-bs-toggle="tooltip"
                        title="ri-download-2-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-delete-bin-line"
                        data-bs-toggle="tooltip"
                        title="ri-delete-bin-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-folder-open-line"
                        data-bs-toggle="tooltip"
                        title="ri-folder-open-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-calendar-2-line"
                        data-bs-toggle="tooltip"
                        title="ri-calendar-2-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-calculator-line"
                        data-bs-toggle="tooltip"
                        title="ri-calculator-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-time-line"
                        data-bs-toggle="tooltip"
                        title="ri-time-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-phone-line"
                        data-bs-toggle="tooltip"
                        title="ri-phone-line"
                      />
                    </div>
                    <div className="icons-list-item">
                      <i
                        className="ri-video-on-line"
                        data-bs-toggle="tooltip"
                        title="ri-video-on-line"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /Chart */}
        </div>
      </div>
    </div>
    {/* /Page Wrapper */}
  </>
  

  );
};
export default RemixIcons;
